// import manage_service from '../../model/manage_service.js';
import axiosCommon from '@/api/axiosCommon'
import axios from "axios";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
import manage_service from "../../model/manage_service";


const BILLING_UNIT_BUY_MODE_MAP = (hasLimitedNum, productId) => ({
    11: "AH",
    12: "最大在线探针数",
    21: "US",
    22: "每小时最大会话数",
    23: "月活",
    24: "月活",
    31: "US",
    32: "每小时最大会话数",
    33: "PV",
    34: "PV",
    41: `${hasLimitedNum ? '数据空间扩展包 ' + productId : '企业版订阅'}`,
    42: "免费版订阅",
    43: "私有化企业版订阅",
    44: "数据空间",
    51: "会话用量",
    71: "US",
    72: "打开次数"
});

let manage = {
    namespaced: true,
    state: {
        condition: {
            activeTimeFrom: "",
            activeTimeTo: "",
            applicantName: "",
            applyTimeFrom: "",
            customerName: "",
            applyTimeTo: "",
            licenseId: "",
            orderNo: "",
            pageNo: 1,
            productType: 0,
            projectName: "",
            sortName: "createTime",
            sortOrder: "desc",
            status: -1,
            versionType: -1,
            pageSize: 20,

        },
        customHeaderData1: [
            {
                title: "License ID",
                dataIndex: "licenseId",
                key: "licenseId",

                width: 130,
                hiddenCol: true,
                itemIsChecked: true,
                slot: 'licenseId'
            },
            {
                title: "License 版本",
                dataIndex: "versionType",
                key: "versionType",
                width: 100,
                itemIsChecked: false,
            },
            {
                title: "项目名称",
                dataIndex: "projectName",
                key: "projectName",
                width: 208,
                itemIsChecked: true,
            },
            {
                title: "相关产品",
                dataIndex: "productTypes",
                key: "productTypes",
                width: 100,
                itemIsChecked: false,
            },
            {
                title: "申请工单号",
                dataIndex: "orderNo",
                key: "orderNo",
                width: 200,
                itemIsChecked: true,
                slot: "orderNo"
            },
            {
                title: "申请人",
                dataIndex: "applicantName",
                key: "applicantName",
                width: 130,
                itemIsChecked: true,
            },
            {
                title: "最终客户",
                itemIsChecked: true,
                dataIndex: "customerName",
                key: "customerName",
                width: 200,
            },
            {
                title: "申请时间",
                itemIsChecked: true,
                dataIndex: "applyTime",
                key: "applyTime",
                sortable: true,
                width: 144,
            },
            {
                title: "生成时间",
                itemIsChecked: true,
                dataIndex: "createTime",
                key: "createTime",

                width: 144,
                defaultSortOrder: 'descend',
                sorter: (a, b) => {
                    let aTime = new Date(a.createTime).getTime();
                    let bTime = new Date(b.createTime).getTime();

                    return aTime - bTime;
                },
            },

            {
                title: "生效时间",
                itemIsChecked: false,
                dataIndex: "activeTime",
                key: "activeTime",
                sortable: true,
                width: 144,
            },
            {
                title: "状态",
                itemIsChecked: true,
                dataIndex: "status",
                width: 68,
                key: "status",
            },
            {
                title: "操作",
                key: "action",
                // scopedSlots: { customRender: 'action' },
                slot: "action",
                hiddenCol: true,
                itemIsChecked: true,
                width: 138,
            },
        ],
        customHeaderData: [],
        tableData: [], // 表格数据源
        isClickTypeFlag: false, // 是否点击了类型，再进行检索
        total: 0,
        showSearchFlag: false,
        disabledDownload: false,
        // 产品列表
        products: [],
        // loading:false

        // pageSize: 10,
        // pageNo:1
    },
    // getters 加工
    getters: {
        // formatTable:state=>{
        //    state.tableData.forEach(item=>{
        //        if(item.status==0){
        //            item.status="未激活"
        //        }
        //        else if(item.status==1){
        //         item.status="已激活"
        //        }
        //       return item;
        //    })
        // },
    },
    // mutation 同步操作
    mutations: {

        // 初始清空
        resetDefault() {
            state.condition.status = -1;
            state.condition.versionType = -1;
            state.condition.productType = 0;
            state.condition.applyTimeFrom = "";
            state.condition.applyTimeTo = "";
            state.condition.activeTimeFrom = "";
            state.condition.activeTimeTo = "";


        },

        changeVersion(state, payload) {
            state.condition.versionType = payload;
            // 第一个参数是目标对象，后面的参数都是源对象
            // 如果目标对象与源对象有同名属性，或多个源对象有同名属性，则后面的属性会覆盖前面的属性。
            // state.condition = Object.assign(state.condition, payload)
        },
        updateSelectCondition(state, payload) {
            state.condition = Object.assign(state.condition, payload);
        },
        alreadyClickType(state, payload) {
            state.isClickTypeFlag = payload;
        },
        updateTotal(state, payload) {
            state.total = payload;
        },

        // 禁用下载
        setDisabledDownload(state, payload) {
            state.total = payload;
        },
        // 更新产品
        setProducts(state, payload) {
            state.products = payload
        },

        updateTableData(state, payload) {
            state.tableData = payload;

        },
        getDefaultCustomHeader(state, payload) {
            state.customHeaderData = payload
        },
        changePageSize(state, data) {
            state.pageSize = data;
        },
        changePageNo(state, data) {
            state.pageSize = data;
        },
        changeItemCheckboxStatus(state, param) {
            state.customHeaderData.map((item, index) => {

                const i = state.customHeaderData.findIndex((item) => item.key === param.key);

                if (i !== -1) {
                    state.customHeaderData[i].itemIsChecked = param.targetStatus;
                }
            });
        },
        updateLoadingStats(state, param) {
            state.loading = param
        }
    },
    // action 异步操作
    actions: {
        // 初始化请求所有
        async getInitTableData({commit}, payload) {
            let result = await axiosCommon.post("/rest/mgmt/getList", {
                activeTimeFrom: "",
                activeTimeTo: "",
                applicantName: "",
                applyTimeFrom: "",
                customerName: "",
                applyTimeTo: "",
                licenseId: "",
                orderNo: "",
                pageNo: 1,
                pageSize: 20,
                productType: 0,
                projectName: "",
                sortName: "",
                sortOrder: "desc",
                status: -1,
                versionType: -1,
            });
            //

            if (result) {
                commit("updateTableData", result.results);
                commit("updateTotal", result.totalRecord);
                return result;
            }
        },

        // 查询 自定义表头
        queryCustomTableHeader({commit}, params) {
            manage_service.queryCustomHeader().then(result => {


                result.data.forEach((item => {

                    // result.data.forEach((item=>{
                    if (item.itemIsChecked === "true") {
                        item.itemIsChecked = true
                    }
                    if (item.itemIsChecked === "false") {
                        item.itemIsChecked = false
                    }


                    //  }

                }))


                commit("getDefaultCustomHeader", result.data)

                return result.data
            })
        },

        // 获取产品列表
        async getProducts({ commit, state}, params) {
            let result = await axiosCommon.post("/rest/mgmt/getProduct");
            if (result) {
                commit("setProducts", result)
            }
        },
        // 更新自定义表头

        // 查询表格数据
        async getTableData({commit, state}, params) {
            let data = {
                pageSize: state.pageSize,
                ...state.condition,
                ...params,
            };
            // commit("updateLoadingStats",true)
            let result = await axiosCommon.post("/rest/mgmt/getList", data);
            // commit("updateLoadingStats",false)


            if (result?.results?.length > 0) {
                result.results.forEach((item) => {

                    if (item.status == 0) {
                        item.status = "未激活";
                    } else if (item.status == 1) {
                        item.status = "已激活";
                    }
                    if (item.versionType == 0) {
                        item.versionType = "License_v2.0";
                        item.originType = 0
                    } else if (item.versionType == 1) {
                        item.versionType = "License_v1.0";
                    } else if (item.versionType == 2) {
                        item.versionType = "License_v1.1";
                    } else if (item.versionType == 3) {
                        item.versionType = "License_v1.2";
                    } else if (item.versionType == 5) {
                        item.versionType = "License_v2.1";
                    } else if (item.versionType == 6) {
                        item.versionType = "License_v2.2";
                    } else {
                        item.versionType = "License_v1.3";
                    }
                    return item;
                });
                // 更新并获得查询后的数据源
                commit("updateTableData", result.results);
                commit("updateTotal", result.totalRecord);

                return result;
            } else {
                commit("updateTableData", []);
            }
        },

        // 根据多功能检索项，展示搜索框检索表项
        async queryDataInType({commit}, params) {
            let result = await axiosCommon.post("/rest/mgmt/getSearch", params);
            if (result) {
                return result;
            }
        },

        // 根据orderNo查询详情
        async queryDetailByOrderNo({commit}, params) {
            let result = await axiosCommon.post("/rest/mgmt/getDetail", params);
            if (result) {
                // var resultList=[result];

                // var arr = [];
                // 计费单元
                // type  '产品类型：1-Server，2-SDK，3-Browser 4- Dataview',
                // envType  License类型  'License类型：1-测试 2-生产',
                result.products.forEach(item => {
                    if (item.limitedNum && item.limitedNum == -1) {
                        item["limitedNum"] = "不限量"
                    }

                    const hasLimitedNum = !!item.limitedNum && item.limitedNum != -1;

                    // if((item.type==2 && item.buyMode==1) || (item.type===3 && item.buyMode==1)){
                    //   item["billingUnit"]="USM"
                    // }
                    // // if(item.name.indexOf('Server') !=-1 &&  item.buyMode==1){
                    // if(item.type==1  &&  item.buyMode==1){
                    //   item["billingUnit"]="AH"
                    // }
                    // if((item.type==2  && item.buyMode==2) || (item.type==3  && item.buyMode==2)){
                    //   item["billingUnit"]="SessionPerHour"
                    // }
                    // // if(item.name.indexOf('Server') !=-1 &&  item.buyMode==2){
                    // if(item.type==1 &&  item.buyMode==2){
                    //   item["billingUnit"]="LiveAgent"
                    // }
                    // // dataview
                    // // deployType   部署环境类型：1-私有化 2-SaaS
                    // // editionType  Dataview标识：1-企业版 2-免费版
                    // if (item.type == 4) {
                    //   if (item.editionType == 2) {
                    //     item["billingUnit"]="免费版订阅"
                    //   }
                    //
                    //   if (item.editionType == 1) {
                    //     if (item.limitedNum) {
                    //       item["billingUnit"]="企业版订阅（GB）";
                    //     }
                    //     if (!item.limitedNum) {
                    //       item["billingUnit"]="企业版订阅";
                    //     }
                    //   }
                    //
                    //   if (!item.editionType && item.deployType == 1) {
                    //     item["billingUnit"]="存储空间（GB）";
                    //   }
                    //
                    //   if (!item.editionType && item.deployType == 2) {
                    //     item["billingUnit"]="数据空间扩展包" + item.id + "（GB）"
                    //   }
                    // }
                    item["billingUnit"] = BILLING_UNIT_BUY_MODE_MAP(hasLimitedNum, item.id)[item.buyMode]
                    return item
                })

                return result;
            }
        },

        // 发送邮件
        async sendEmailByOrderNo({commit}, params) {
            let result = await axiosCommon.post("/rest/mgmt/sendMail", params);
            if (result) {
                return result;
            }
        },


        // 导出
        async exportTable({commit}, params) {
            let result = await axiosCommon.post("/rest/mgmt/getList", params);
            if (result) {
                return result;
            }
        }


    },
};

export default manage;
